import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FireBaseService } from '../../../services/fire-base.service';
import { regexp } from '../../../validators/regexp';
import { CommonModule } from '@angular/common';
import { StorageService } from '../../../services/storage.service';
import { RESY_TOKEN } from '../../../constants/storage-keys';
import { PopupService } from '../../../services/popup.service';
import { LoaderService } from '../../../services/loader.service';
import { environment } from '../../../../../environments/environment';
import { BaseComponent } from '../../base/base.component';
import { phonePrefixHandler } from '../../../helpers/phone-prefix';
import {
  DUMMY_PHONE_NUMBER,
  GUEST_ID,
  TOKEN_DUMMY_USER,
} from '../../../constants/headers';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule],
})
export class LoginRegisterComponent extends BaseComponent implements OnInit {
  @Input() isMobile = true;
  public phoneNumberControl: UntypedFormControl;
  public submitted = false;
  @ViewChild('recaptchaBlock', { read: ElementRef, static: true })
  public recaptchaBlock: ElementRef<HTMLDivElement>;

  constructor(
    private authService: AuthService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private fireBaseService: FireBaseService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private popupService: PopupService,
    private loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit() {
    this.authService.redirectUrl =
      this.activatedRoute.snapshot.queryParamMap.get('redirectTo');
    const resyToken =
      this.activatedRoute.snapshot.queryParamMap.get('resyToken');
    this.storageService.saveToStorage<string>(RESY_TOKEN, resyToken);
    this.phoneNumberControl = this.fb.control('', [
      Validators.required,
      Validators.pattern(regexp.phoneNumber),
    ]);
  }

  public sendVerification(): void {
    if (this.phoneNumberControl.valid && !this.submitted) {
      const controlValue = this.phoneNumberControl.value;
      let phoneNumber = controlValue.replace(/\D/g, '');
      if (DUMMY_PHONE_NUMBER === phoneNumber) {
        this.storageService.saveToStorage(GUEST_ID, TOKEN_DUMMY_USER);
        this.authService.login(TOKEN_DUMMY_USER).subscribe(() => {
          this.router.navigate(['/my/account']);
        });
        return;
      }
      phoneNumber =
        phoneNumber.length === 10 ? `+1${phoneNumber}` : `+${phoneNumber}`;
      this.loaderService.show();
      this.submitted = true;
      this.fireBaseService
        .signInWithPhoneNumber(phoneNumber)
        .then((error: void | Error) => {
          if (error) {
            this.popupService.showErrorResponsePopup(error.message);
            this.submitted = false;
            this.loaderService.hide();
            this.reCreateRecaptcha();
            return;
          }
          this.fireBaseService.phoneRegistered = true;
          this.router.navigateByUrl(
            `/auth/verification/${this.phoneNumberControl.value}`
          );
        })
        .catch((err) => {
          this.submitted = false;
          this.popupService.showErrorResponsePopup(err.message);
          console.error(err);
        })
        .finally(() => this.loaderService.hide());
    }
  }

  public onKeyup(): void {
    if (!environment.production) {
      return;
    }
    phonePrefixHandler(this.phoneNumberControl);
  }

  private reCreateRecaptcha(): void {
    this.recaptchaBlock.nativeElement.children[0].remove();
    const newCaptcha = this.renderer.createElement('div');
    this.renderer.setAttribute(newCaptcha, 'id', 'recaptcha-container');
    this.recaptchaBlock.nativeElement.appendChild(newCaptcha);
  }
}
